import { pipe } from '@gov-nx/core/types/pipe';

export const toPercentageReadable = (input: number): string =>
	pipe(
		input,
		(number) => (number === 0 || number === 100 ? number : number.toFixed(1)),
		(value) => [value, '%'].join(' ')
	);
